// extracted by mini-css-extract-plugin
export default {"dialogContentContainer":"ExperimentsDialog-module__dialogContentContainer--mWDus","experimentsInput":"ExperimentsDialog-module__experimentsInput--Uko5H"};